/* Kindly offer maths + bundle-builder state. Pure functions, no DOM. Used by kindly-pdp.js, kindly-cart.js
   and the Node tests (v2/test/offer.test.js).
   The free-pair rules mirror the two live automatic discounts on the all-prints collection
   ("Kindly: Buy 1, Get 1 FREE" and "Kindly: Buy 2, Get 3 FREE", each once per order, Shopify applies the better one).
   Verified with draftOrderCalculate on mixed prints and sizes, 8 Oct 2026:
   1 pair 29.99 | 2 29.99 | 3 59.98 | 4 89.97 | 5 59.98 | 6 89.97 | 7 119.96 ... 12 269.91 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.KindlyOffer = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var RULES = [{ min: 5, free: 3, code: 'B2G3', label: 'Buy 2, Get 3 FREE' }, { min: 2, free: 1, code: 'B1G1', label: 'Buy 1, Get 1 FREE' }];
  var TIERS = [1, 2, 5];
  var DEFAULT_ORDER = ['sunny-days', 'cat-nap', 'polka-pop', 'rainbow-stroll', 'heart-of-gold', 'pumpkin-spice'];

  function rule(n) {
    for (var i = 0; i < RULES.length; i++) if (n >= RULES[i].min) return RULES[i];
    return null;
  }
  function freeCount(n) { var r = rule(n); return r ? r.free : 0; }
  /* cents to pay for n pairs at unit cents each */
  function pay(n, unit) { return Math.max(0, n - freeCount(n)) * unit; }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  /* "$12" style per-pair price, rounded to the nearest dollar (59.98/5 = 11.996 -> $12; 29.99/2 = 14.995 -> $15) */
  function perPairWhole(n, unit) { return '$' + Math.round(pay(n, unit) / n / 100); }

  function tierInfo(tier, unit) {
    var p = pay(tier, unit), compare = tier * unit;
    return {
      pairs: tier,
      pay: p,
      compareAt: compare,
      free: freeCount(tier),
      payText: money(p),
      compareText: tier > 1 ? money(compare) : '',
      perPairText: tier > 1 ? perPairWhole(tier, unit) + ' a pair' : money(unit) + ' a pair',
      priceLine: tier === 1 ? money(p) + ' for 1 pair' : money(p) + ' for ' + tier + ' pairs · ' + perPairWhole(tier, unit) + ' a pair',
      atcLabel: 'Add ' + tier + (tier === 1 ? ' pair' : ' pairs') + ' to cart · ' + money(p),
      stickyLabel: tier + (tier === 1 ? ' pair' : ' pairs') + ' · ' + money(p),
      bundle: tier === 5 ? 'B2G3' : tier === 2 ? 'B1G1' : 'single'
    };
  }

  function parseTier(search, fallback) {
    var m = /[?&]tier=(\d+)/.exec(search || '');
    var t = m ? parseInt(m[1], 10) : NaN;
    return TIERS.indexOf(t) >= 0 ? t : (fallback || 5);
  }

  /* Print order for prefilling: the landed print first, then the others in catalogue order. */
  function prefillOrder(landed, slugs) {
    slugs = slugs && slugs.length ? slugs : DEFAULT_ORDER;
    var out = [];
    if (landed && slugs.indexOf(landed) >= 0) out.push(landed);
    slugs.forEach(function (s) { if (out.indexOf(s) < 0) out.push(s); });
    return out;
  }

  /* Builder state: { tier, size, picks: [slug,...], order: [slug,...], sizes: [size|null,...] }
     size = the one size for every pair; sizes[i] = optional per-pair override (the ?view=lp rows, a pair for someone else). */
  function createState(opts) {
    var order = prefillOrder(opts.landed, opts.slugs);
    var s = { tier: 1, size: opts.size || null, picks: [], order: order, sizes: [] };
    return setTier(s, opts.tier || 5);
  }

  /* Switching tier keeps the pairs already chosen; new rows get prints not used yet (then cycle). */
  function setTier(state, tier) {
    if (TIERS.indexOf(tier) < 0) tier = 5;
    var picks = state.picks.slice(0, tier);
    while (picks.length < tier) {
      var unused = state.order.filter(function (s) { return picks.indexOf(s) < 0; });
      picks.push(unused.length ? unused[0] : state.order[picks.length % state.order.length]);
    }
    return { tier: tier, size: state.size, picks: picks, order: state.order, sizes: (state.sizes || []).slice(0, tier) };
  }
  function setPick(state, index, slug) {
    var picks = state.picks.slice();
    if (index >= 0 && index < picks.length) picks[index] = slug;
    return { tier: state.tier, size: state.size, picks: picks, order: state.order, sizes: (state.sizes || []).slice() };
  }
  function sameForAll(state) {
    var p = state.picks.map(function () { return state.picks[0]; });
    return { tier: state.tier, size: state.size, picks: p, order: state.order, sizes: (state.sizes || []).slice() };
  }
  /* The main size applies to every pair again (per-pair overrides are cleared). */
  function setSize(state, size) { return { tier: state.tier, size: size, picks: state.picks.slice(), order: state.order, sizes: [] }; }
  /* Per-pair size override; a size equal to the main size clears the override. */
  function setPairSize(state, index, size) {
    var sizes = (state.sizes || []).slice();
    if (index >= 0 && index < state.picks.length) sizes[index] = size && size !== state.size ? size : null;
    return { tier: state.tier, size: state.size, picks: state.picks.slice(), order: state.order, sizes: sizes };
  }
  function sizeOf(state, index) { return (state.sizes && state.sizes[index]) || state.size || null; }
  /* First row that is free and could take a new print (used by the prints showcase: "tap = sets the next pair") */
  function setNextPick(state, slug, cursor) {
    var i = (cursor || 0) % state.picks.length;
    return { state: setPick(state, i, slug), index: i, next: (i + 1) % state.picks.length };
  }

  /* Which rows are free: the last `free` rows of the tier (BOGO: pair 2; B2G3: pairs 3-5). */
  function freeFlags(tier) {
    var f = freeCount(tier), out = [];
    for (var i = 0; i < tier; i++) out.push(i >= tier - f);
    return out;
  }

  /* catalog: { slug: { name, variants: { size: { id, available } } } }
     Returns { ok, items, problems } ; items merges same-print rows into one line with quantity. */
  function itemsPayload(state, catalog) {
    var problems = [], lines = {}, order = [];
    if (state.picks.some(function (s, i) { return !sizeOf(state, i); })) problems.push({ type: 'size' });
    state.picks.forEach(function (slug, i) {
      var p = catalog[slug], sz = sizeOf(state, i);
      var v = p && sz ? p.variants[sz] : null;
      if (!p || (sz && !v)) { problems.push({ type: 'missing', index: i, slug: slug }); return; }
      if (!v) return;
      if (!v.available) { problems.push({ type: 'soldout', index: i, slug: slug }); return; }
      if (!lines[v.id]) { lines[v.id] = 0; order.push(v.id); }
      lines[v.id] += 1;
    });
    var bundle = state.tier === 5 ? 'B2G3' : state.tier === 2 ? 'B1G1' : 'single';
    var items = order.map(function (id) { return { id: id, quantity: lines[id], properties: { _bundle: bundle } }; });
    return { ok: problems.length === 0, items: items, problems: problems };
  }

  /* "Sold out for now · Back soon" mode: true only when there is at least one print and NONE of them has an available
     variant. prints = catalog list [{ variants: { size: { available } } }]. Same rule as snippets/kindly-soldout.liquid. */
  function allSoldOut(prints) {
    if (!prints || !prints.length) return false;
    return !prints.some(function (p) {
      var vs = p && p.variants ? p.variants : {};
      return Object.keys(vs).some(function (k) { return vs[k] && vs[k].available; });
    });
  }
  var SOLDOUT = { atc: 'Sold out for now · Back soon', sticky: 'Sold out for now · Back soon', stickyBtn: 'Email me' };

  /* Cart progress in pairs. pairs = Kindly pairs in the cart, unit = cents per pair. */
  var NODES = [{ at: 1, label: '1 pair' }, { at: 2, label: '2 pairs · Buy 1 Get 1' }, { at: 5, label: '5 pairs · Buy 2 Get 3 FREE' }];
  function cartProgress(pairs, unit, saved) {
    var res = { pairs: pairs, percent: Math.min(pairs, 5) / 5 * 100, nodes: NODES.map(function (n) { return { label: n.label, done: pairs >= n.at }; }), message: '', freeNext: false, addCount: 0 };
    if (pairs <= 0) { res.message = 'Buy 1, Get 1 FREE and Buy 2, Get 3 FREE come off automatically.'; return res; }
    var target = null;
    for (var i = 0; i < RULES.length; i++) if (RULES[i].min > pairs && (target === null || RULES[i].min < target)) target = RULES[i].min;
    if (target === null) {
      var s = typeof saved === 'number' ? saved : freeCount(pairs) * unit;
      res.message = 'Buy 2 Get 3 FREE unlocked. You save ' + money(s) + '.';
      if (pairs > 5) res.message += ' Pairs 6 and up are ' + money(unit) + ' each.';
      return res;
    }
    var add = target - pairs, delta = pay(target, unit) - pay(pairs, unit);
    res.addCount = add;
    var pairWord = add === 1 ? 'pair' : 'pairs';
    if (delta <= 0) {
      res.freeNext = true;
      res.message = 'Add ' + add + ' more ' + pairWord + '. ' + (add === 1 ? "It's FREE" : "They're FREE");
      res.message += delta < 0 ? ", and you'll pay " + money(-delta) + ' less.' : '.';
    } else {
      res.message = (freeCount(pairs) > 0 ? 'Buy 1 Get 1 is on. ' : '') + 'Add ' + add + ' more ' + pairWord + ' for ' + money(delta) +
        ' and get ' + target + ' pairs (' + perPairWhole(target, unit) + ' a pair).';
    }
    return res;
  }

  return {
    RULES: RULES, TIERS: TIERS, DEFAULT_ORDER: DEFAULT_ORDER,
    freeCount: freeCount, pay: pay, money: money, perPairWhole: perPairWhole, tierInfo: tierInfo, parseTier: parseTier,
    prefillOrder: prefillOrder, createState: createState, setTier: setTier, setPick: setPick, sameForAll: sameForAll,
    setSize: setSize, setPairSize: setPairSize, sizeOf: sizeOf, setNextPick: setNextPick, freeFlags: freeFlags, itemsPayload: itemsPayload, cartProgress: cartProgress,
    allSoldOut: allSoldOut, SOLDOUT: SOLDOUT
  };
});
